import { createContext } from "react";
const ThemeManagerContext = createContext(null);
export {
  ThemeManagerContext
};
//# sourceMappingURL=ThemeManagerContext.js.map
